(function (angular) {
  'use strict';

  //URL LOGIN
  var urlLogin = {
    url: '/DFAUTH/slod_mult_mult/DFServlet',
    urlMock: 'https://eup-grupobbva2.igrupobbva/DFAUTH/slod_mult_mult/DFServlet',
    mock: false,
    method: 'POST'
  };

  //URL LOGOUT
  var urlLogout = {
    url: '/pkmslogout.form?filename=logout_kyop.html',
    urlMock: 'https://eup-grupobbva2.igrupobbva/pkmslogout.form?filename=logout_kyop.html',
    mock: false,
    method: 'POST'
  };

  //URL OLVIDO
  var urlOlvido = {
    url: '/DFAUTH/slod_mult_mult/DRServlet',
    urlMock: 'https://eup-grupobbva2.igrupobbva/DFAUTH/slod_mult_mult/DRServlet',
    mock: false,
    method: 'POST'
  };

  //URL BOSS
  var urlBoss = {
    url: '/SESEYPH/eyph_mult_web_pub/boss',
    urlMock: 'https://eup-grupobbva2.igrupobbva/SESEYPH/eyph_mult_web_pub/boss',
    mock: false,
    method: 'POST'
  };

  var origen = location.origin.split('.').slice(1).join('.');
  var basePath;
  // www.bbvaoneview.com -> bbvaoneview.com
  switch (origen) {
    case 'ad.bbva.com:3000': // local
      basePath = 'https://d1z5tqtqqbiamk.cloudfront.net';
      break;

    case 'igrupobbva': // pre-produccion
      basePath = 'https://d1z5tqtqqbiamk.cloudfront.net';
      break;

    case 'bbvaoneview.com': // produccion
      basePath = 'https://jiofwv2h.openweb.bbva';
      break;

    default:

  }
  var path = basePath + '/wp-content/themes/bbva/angular-static';

  angular.module('bossApp.constants', [])
    .constant('URLS', {
      urlOpenweb: path,
      urlLogin: urlLogin,
      urlLogout: urlLogout,
      urlOlvido: urlOlvido,
      urlBoss: urlBoss
    })
    .constant('user', {
      // TODO: cuado se abilite es uso de servicios atraves de boss cambiarlo
      origen: 'pibee_es' || 'boss',
      idioma: 'CAS',
      eai_user: '',
      eai_URLDestino: '/SESKYOP/kyop_mult_web_pub/index-new.html',
      error: ''
    });
})(window.angular);
